export default "__VITE_ASSET__DMNFkPmA__"